module.exports = __webpack_public_path__ + "img/cv_2.dbd3df74.png";